import { popoverClasses } from '@mui/material';

import { popoverArrowClasses } from '../PopoverArrow';

import type { ThemeOptions } from '@mui/material';
import type { PopoverProps } from './types';

export const popoverThemes: ThemeOptions['components'] = {
  MuiPopover: {
    styleOverrides: {
      paper: () => ({
        backgroundColor: 'transparent',
        borderRadius: 0,
        boxShadow: 'none',
        width: 'fit-content',
        position: 'relative',
        overflowX: 'unset',
        overflowY: 'unset',
      }),
    },
    variants: [
      {
        props: { placement: 'top' } as PopoverProps,
        style: () => ({
          [`& .${popoverClasses.paper}`]: {
            marginTop: -4,
            [`&:has([class$="${popoverArrowClasses.root}"])`]: {
              marginTop: -12,
            },
          },
        }),
      },
      {
        props: { placement: 'bottom' } as PopoverProps,
        style: () => ({
          [`& .${popoverClasses.paper}`]: {
            marginTop: 4,
            [`&:has([class$="${popoverArrowClasses.root}"])`]: {
              marginTop: 12,
            },
          },
        }),
      },
      {
        props: { placement: 'left' } as PopoverProps,
        style: () => ({
          [`& .${popoverClasses.paper}`]: {
            marginLeft: -4,
            [`&:has([class$="${popoverArrowClasses.root}"])`]: {
              marginLeft: -12,
            },
          },
        }),
      },
      {
        props: { placement: 'right' } as PopoverProps,
        style: () => ({
          [`& .${popoverClasses.paper}`]: {
            marginLeft: 4,
            [`&:has([class$="${popoverArrowClasses.root}"])`]: {
              marginLeft: 12,
            },
          },
        }),
      },
    ],
  },
};
